import cloneDeep from 'lodash.clonedeep';
import { GroupedNavigationLinks } from '../../../../core/models/grouped-navigation-links';
import { environment } from '../../../../../environments/environment';

/**
 * Retrieves a deep copy of header links. This is useful when dispay text needs to be modified
 * (i.e. adding line breaks) without modifying the original header link object reference.
 * @returns header links array
 */
export const getHeaderLinksCopy = (): GroupedNavigationLinks[] => {
    return cloneDeep(headerLinks);
};

const ewaWebsiteUrl = environment.ewaWebsiteUrl;

const headerLinks: GroupedNavigationLinks[] = [
    {
        text: 'Advocacy',
        url: 'https://www.enterprisewireless.org/advocacy',
        childLinks: [
            {
                text: 'Advocacy Priorities',
                url: 'https://www.enterprisewireless.org/advocacy-priorities',
            },
            {
                text: 'Federal Filings',
                url: 'https://www.enterprisewireless.org/federal-filings',
            },
            {
                text: 'Regulatory Call',
                url: 'https://www.enterprisewireless.org/attend-ewa-regulatory-call',
            },
        ],
    },
    {
        text: 'Spectrum Solutions',
        url: 'https://www.enterprisewireless.org/spectrum-solutions',
        childLinks: [
            {
                text: 'Spectrum Intel™',
                url: `${ewaWebsiteUrl}/spectrumintel`,
            },
            {
                text: 'Mapping & Research',
                url: `${ewaWebsiteUrl}/services/mapping-research`,
            },
            {
                text: 'License Management',
                url: `${ewaWebsiteUrl}/services/license-management`,
            },
            {
                text: 'License Bank™',
                url: 'https://www.enterprisewireless.org/services/license-bank',
            },
            {
                text: 'Service Fees',
                url: 'https://www.enterprisewireless.org/service-fees',
            },
        ],
    },
    {
        text: 'Frequency Coordination',
        url: 'https://www.enterprisewireless.org/frequency-coordination',
        childLinks: [
            {
                text: 'Cevo®',
                url: `${ewaWebsiteUrl}/cevo`,
            },
            {
                text: 'Cevo Go®',
                url: `${ewaWebsiteUrl}/cevogo`,
            },
            {
                text: 'Filing Assistance',
                url: `${ewaWebsiteUrl}/services/filing-assistance`,
            },
            {
                text: 'Contact Your Spectrum Advisor',
                url: 'https://www.enterprisewireless.org/contact',
            },
            {
                text: 'MBAN Registration',
                url: 'https://www.mbanregistration.org/',
            },
            {
                text: 'Service Fees',
                url: 'https://www.enterprisewireless.org/service-fees',
            },
        ],
    },
    {
        text: 'Services',
        url: 'https://www.enterprisewireless.org/services',
        childLinks: [
            {
                text: 'Spectrum Intel™',
                url: `${ewaWebsiteUrl}/spectrumintel`,
            },
            {
                text: 'Cevo®',
                url: `${ewaWebsiteUrl}/cevo`,
            },
            {
                text: 'Cevo Go®',
                url: `${ewaWebsiteUrl}/cevogo`,
            },
            {
                text: 'License Bank™',
                url: 'https://www.enterprisewireless.org/services/license-bank',
            },
            {
                text: 'License Management',
                url: `${ewaWebsiteUrl}/services/license-management`,
            },
            {
                text: 'EWA Connect',
                url: 'https://connect.enterprisewireless.org/portal/custom?renderUrl=11',
            },
            {
                text: 'Wireless Solutions Center',
                url: 'https://www.wirelesssolutionscenter.com/',
            },
            {
                text: 'MBAN Registration',
                url: 'https://www.mbanregistration.org/',
            },
            {
                text: 'Service Fees',
                url: 'https://www.enterprisewireless.org/service-fees',
            },
        ],
    },
    {
        text: 'Education & Events',
        url: 'https://www.enterprisewireless.org/education-events',
        childLinks: [
            {
                text: 'Wireless Leadership Summit',
                url: 'https://www.enterprisewireless.org/wls',
            },
            {
                text: 'Wireless Solutions Center',
                url: 'https://www.wirelesssolutionscenter.com/',
            },
            {
                text: 'Private Wireless Education Council',
                url: 'https://www.enterprisewireless.org/content/private-wireless-education-council',
            },
            {
                text: 'EWA-Joseph B. Vestal Scholarship',
                url: 'https://www.enterprisewireless.org/about/scholarship',
            },
            {
                text: 'Webinars & Events',
                url: 'https://www.enterprisewireless.org/webinars-events',
            },
        ],
    },
    {
        text: 'Membership',
        url: 'https://www.enterprisewireless.org/membership',
        childLinks: [
            {
                text: 'Join Now!',
                url: 'https://www.enterprisewireless.org/membership',
            },
            {
                text: 'Member Benefits',
                url: 'https://www.enterprisewireless.org/member-benefits',
            },
            {
                text: 'EWA Connect',
                url: 'https://connect.enterprisewireless.org/portal/custom?renderUrl=11',
            },
            {
                text: 'Wireless Investment Model',
                url: 'https://www.enterprisewireless.org/wireless-system-investment-model',
            },
        ],
    },
    {
        text: 'News',
        url: 'https://www.enterprisewireless.org/news-and-events',
        childLinks: [
            {
                text: "Crosby's Blog",
                url: 'https://www.enterprisewireless.org/blog',
            },
            {
                text: 'News',
                url: 'https://www.enterprisewireless.org/news-and-events',
            },
        ],
    },
    {
        text: 'About',
        url: 'https://www.enterprisewireless.org/about',
        childLinks: [
            {
                text: 'Mission & History',
                url: 'https://www.enterprisewireless.org/mission-history',
            },
            {
                text: 'Board of Directors',
                url: `${ewaWebsiteUrl}/about/board-of-directors`,
            },
            {
                text: 'Leadership Team',
                url: 'https://www.enterprisewireless.org/leadership-team',
            },
            {
                text: 'Critical Alliances',
                url: 'https://www.enterprisewireless.org/critical-alliances',
            },
            {
                text: 'Annual Report',
                url: 'https://www.enterprisewireless.org/content/annual-reports',
            },
            {
                text: 'Contact Your Spectrum Advisor',
                url: 'https://www.enterprisewireless.org/contact',
            },
        ],
    },
];
